import React from 'react';
import {
  IconButton,
  Tooltip,
  Fade,
} from '@mui/material';
import {
  DarkMode as DarkModeIcon,
  LightMode as LightModeIcon,
} from '@mui/icons-material';
import { useTheme } from '../contexts/ThemeContext';

const DarkModeToggle: React.FC = () => {
  const { isDark, toggleMode } = useTheme();

  return (
    <Tooltip
      title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      arrow
      TransitionComponent={Fade}
      placement="bottom"
    >
      <IconButton
        onClick={toggleMode}
        size="small"
        sx={{
          p: 1,
          borderRadius: 2,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            bgcolor: 'action.hover',
            transform: 'scale(1.05)',
          },
        }}
      >
        {isDark ? (
          <LightModeIcon
            sx={{
              fontSize: 20,
              color: 'warning.main',
              transition: 'all 0.3s ease',
            }}
          />
        ) : (
          <DarkModeIcon
            sx={{
              fontSize: 20,
              color: 'text.secondary',
              transition: 'all 0.3s ease',
            }}
          />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default DarkModeToggle;
